"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledListUnordered = exports.StyledListOrdered = exports.StyledItemRightChild = exports.StyledItemLeftChild = exports.StyledItemChild = exports.StyledListItem = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../utils/theme");
var listCounter = 'list-counter';
var commonStyles = {
    alignItems: 'center'
};
exports.StyledListItem = styled_components_1.default.li(__assign(__assign({}, theme_1.font), { alignItems: 'center', breakInside: 'avoid', display: 'flex', fontSize: '16px', listStyle: 'none', padding: theme_1.scaffolding.sm + " " + theme_1.scaffolding.md }), function (_a) {
    var flexDirection = _a.flexDirection, justifyContent = _a.justifyContent;
    return ({
        flexDirection: flexDirection,
        justifyContent: justifyContent
    });
});
exports.StyledItemChild = styled_components_1.default.span(__assign({}, commonStyles));
exports.StyledItemLeftChild = styled_components_1.default.span(__assign({}, commonStyles));
exports.StyledItemRightChild = styled_components_1.default.span(__assign(__assign({}, commonStyles), { fontSize: '19px', fontWeight: theme_1.fontWeights.bold, textAlign: 'right' }), function (_a) {
    var flexDirection = _a.flexDirection;
    return ({
        margin: flexDirection === 'row'
            ? "0px 0px 0px " + theme_1.scaffolding.md
            : "0px " + theme_1.scaffolding.md + " 0px 0px"
    });
});
exports.StyledListOrdered = styled_components_1.default.ol(__assign(__assign({}, theme_1.font), (_a = { columnGap: theme_1.scaffolding.lg, counterReset: listCounter, margin: '0px', padding: '0px' }, _a["" + exports.StyledListItem] = (_b = {
        counterIncrement: listCounter
    },
    _b[exports.StyledItemChild + ", " + exports.StyledItemLeftChild] = {
        ':before': {
            content: "counter(" + listCounter + ") '.'",
            fontWeight: theme_1.fontWeights.bold,
            marginRight: theme_1.scaffolding.sm
        }
    },
    _b), _a)), function (_a) {
    var columnCount = _a.columnCount;
    return ({
        columnCount: columnCount,
        columnRule: columnCount ? "1px solid " + theme_1.colors.grey2 : 'none'
    });
});
exports.StyledListUnordered = styled_components_1.default.ul(__assign(__assign({}, theme_1.font), { columnGap: theme_1.scaffolding.lg, margin: '0px', padding: '0px' }), function (_a) {
    var columnCount = _a.columnCount;
    return ({
        columnCount: columnCount,
        columnRule: columnCount ? "1px solid " + theme_1.colors.grey2 : 'none'
    });
});
//# sourceMappingURL=styles.js.map